// Moved to the garage-scoped API: mechanics now belong to a garage tenant,
// so this goes through ./crud (garage-token request helper), not adminHeaders.
import { makeCrud } from "./crud";

const crud = makeCrud("mechanics");

export const fetchMechanics  = (filters, signal) => crud.list(filters, signal);
export const fetchMechanic   = crud.get;
export const createMechanic  = crud.create;
export const updateMechanic  = crud.update;
export const deleteMechanic  = crud.remove;